/* eslint-disable import/prefer-default-export */
import { useState } from 'react';
import _noop from 'lodash-es/noop';

import { putCollectionPreferences } from 'PrivateAPI';

import { isApplicationNonProd } from 'Utilities/helpers';
import { safeLocalStorage } from 'Utilities/storages';

export class UpdatePreferencesError extends Error {
  statusCode: number;

  constructor(message: string, statusCode: number) {
    super(message);
    this.name = 'UpdatePreferencesError';
    this.statusCode = statusCode;
  }
}

interface UseUpdateParams {
  onError?: (err: unknown) => void;
  onSuccess?: () => void;
}

interface UpdatePreferencesParams {
  datePreferences: string[];
  dpEnquiryId?: number
}

// @ts-ignore this is for mocking
const performMockIfNotOnProduction: any = async (cb: () => Promise<any>, payload: UpdatePreferencesParams) => {
  if (isApplicationNonProd) {
    const notAvailableDates = JSON.parse(safeLocalStorage.getItem('scpDatesNotAvailableArray') || '[]');
    const payloadDates = payload.datePreferences; // assumes payload has a dates property

    // Check if any date from payload is in the not available dates
    const hasUnavailableDates = payloadDates.some((date: string) => notAvailableDates.includes(date));

    if (hasUnavailableDates) {
      // Mock 400 error response

      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            json() {
              return {
                message: 'Requested date is not available',
              };
            },
            status: 400,
          });
        }, 1000);
      });
    }
  }
  return cb();
};

export const useUpdatePreferences = ({
  onError = _noop,
  onSuccess = _noop,
}: UseUpdateParams = {}) => {
  const [loading, setLoading] = useState(false);

  const updatePreferences = async (updateParams: UpdatePreferencesParams) => {
    setLoading(true);

    const { datePreferences, dpEnquiryId } = updateParams;
    const payload = {
      datePreferences,
      isSubmitted: true,
    };

    try {
      if (!Number.isInteger(dpEnquiryId)) {
        throw new Error('Enquiry ID is invalid or not supplied.');
      }

      await performMockIfNotOnProduction(
        () => putCollectionPreferences(dpEnquiryId, payload),
        payload,
      );

      onSuccess();
    } catch (e) {
      onError(e);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    updatePreferences,
  };
};
